"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable max-len */
// values in this file are never directly used in components but set the 'base theme' properties

/*
  These are the standard rootBorders
 */
var rootBorders = {
  border100: {
    category: 'border',
    commonUses: ['Defines width and type', 'Buttons'],
    dataType: 'border',
    value: '1px solid'
  }
};
var _default = rootBorders;
exports.default = _default;